import type { Environment } from "../../../types";
import type { GlobalMenu } from "../../app-launcher/types";

export const ONE_USD_SITE_URLS: Record<Environment, string> = {
  dev: "https://stg.oneusd.money/",
  stage: "https://stg.oneusd.money/",
  production: "https://www.oneusd.money/",
};

export function isOneUsdHostname(hostname: string): boolean {
  const normalized = hostname.trim().toLowerCase().replace(/\.$/, "");
  return normalized === "oneusd.money" || normalized.endsWith(".oneusd.money");
}

export function resolveOneUsdSiteUrl(
  config: GlobalMenu | null | undefined,
  env: Environment,
): string | undefined {
  const item = config?.items?.find(
    ({ id, type }) => id.toLowerCase() === "oneusd" || type.toLowerCase() === "oneusd",
  );
  return item?.url[env];
}
